import React, { useState, useEffect } from "react";
import "./Material.css";
import { Container } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";

import foamFitment  from "../assets/images/customized-epe-foam-fitment.jpg";
import foamFitment1 from "../assets/images/customized-epe-foam-fitment1.jpg";
import foamTray     from "../assets/images/customized-epe-foam-tray.jpg";
import evaFoam      from "../assets/images/customized-eva-packaging-foam.jpg";
import hdFoamTray   from "../assets/images/customized-high-density-foam-tray.jpg";
import hdFoam       from "../assets/images/customized-high-density-packaging-foam.jpg";
import packFitment  from "../assets/images/customized-packaging-foam-fitment.jpg";
import selfAdhesive from "../assets/images/customized-self-adhesive-foam-tape.jpg";
import epeGasket    from "../assets/images/epe-foam-gasket1.jpg";
import epeProfile   from "../assets/images/epe-foam-profile.jpg";
import foamCorner   from "../assets/images/foam-corner-profile1.jpg";
import foamFab      from "../assets/images/foam-fabricated-parts.jpg";
import puGasket     from "../assets/images/pu-foam-gasket.jpg";
import puProfile    from "../assets/images/pu-profile-foam.jpg";
import whiteBracket from "../assets/images/white-epe-foam-bracket.jpg";
import ipm1 from "../assets/images/ipm-1.jpg";
import ipm2 from "../assets/images/ipm-2.webp";
import ipm3 from "../assets/images/ipm-3.webp";
import ipm4 from "../assets/images/ipm-4.jpg";
import CorrugatedBox from "../assets/images/CorrugatedShippingBox.jpg";
import DieCutBox from "../assets/images/Die-Cut Box.jpg";
import PlywoodBox from "../assets/images/Plywood Box.jpg";
import RegularSlottedContainer from "../assets/images/Regular Slotted Container (RSC).jpg";
import BoxesPallets from "../assets/images/BoxesPallets.jpg";


import CordedPolyesterStrapping from "../assets/images/Corded Polyester Strapping.jpg";
import PaperStrapping from "../assets/images/Paper Strapping.jpg";
import PolyesterStrapping from "../assets/images/Polyester Strapping.jpg";
import PolypropyleneStrapping from "../assets/images/Polypropylene Strapping (PP Strapping).jpg"

import MemoryFoamPackaging from "../assets/images/Memory Foam Packaging.jpg";
import PUFoamProducts from "../assets/images/PU Foam Products.jpg";
import PUFoamRoll from "../assets/images/PU Foam Roll.jpg";


import StretchFilmBubbleRoll from "../assets/images/Stretch Film & Bubble Roll.jpg"

import HotMeltTape from "../assets/images/Hot Melt Tape.jpg";
import PressureSensitiveTape from "../assets/images/Pressure Sensitive Tape (PS Tape).jpg"


import ms1  from "../assets/images/manufacture & supply-1.jpg";
import ms2  from "../assets/images/manufacture & supply-2.jpg";
import ms3  from "../assets/images/manufact & supply-3.jpg";

/* Every category has exactly 3 images */
const categoryData = {
  "EPE Foam Products": [
    { name: "EPE Foam Fitment",      image: foamFitment },
    { name: "EPE Foam Fitment 2",    image: foamFitment1 },
    { name: "EPE Foam Tray",         image: foamTray },
    // { name: "EPE Foam Gasket",       image: epeGasket },
    { name: "EPE Foam Profile",      image: epeProfile },
    { name: "White EPE Foam Bracket",image: whiteBracket },
  ],
  "EVA & HD Foam": [
    { name: "EVA Packaging Foam",    image: evaFoam },
    { name: "HD Foam Tray",          image: hdFoamTray },
    { name: "HD Packaging Foam",     image: hdFoam },
  ],
  "Customized Foam": [
    { name: "Packaging Foam Fitment",image: packFitment },
    { name: "Self Adhesive Foam Tape",image: selfAdhesive },
    { name: "Foam Fabricated Parts", image: foamFab },
    { name: "Foam Corner Profile",   image: foamCorner },
    { name: "PU Foam Gasket",        image: puGasket },
    { name: "Convoluted PU Foam (Egg Crate)",       image: puProfile },
  ],
  "PU Foam Products": [
    { name: "PU Foam Gasket",        image: puGasket },
    { name: "Convoluted PU Foam (Egg Crate)",       image: puProfile },
    { name: "Foam Corner Profile",   image: foamCorner },

    { name: "Memory Foam Packaging",   image: MemoryFoamPackaging },
    { name: "PU Foam Products",   image: PUFoamProducts },
    { name: "PU Foam Roll", image: PUFoamRoll },

  ],
  


  "Stretch Film & Bubble Roll": [
    { name: "Stretch Film",          image: ipm1 },
    { name: "Stretch Film & Bubble Roll",          image: StretchFilmBubbleRoll },
    // { name: "Air Bubble Roll",       image: ipm2 },
    // { name: "Foam Sheet Roll",       image: ms1 },
  ],
  "Tape Products": [
    { name: "Hot Melt Tape",             image: HotMeltTape },
    { name: "Printed Tape",          image: ms1 },
    { name: "Specialty Tapes",       image: ms2 },
    { name: "Pressure Sensitive Tape (PS Tape)",       image: PressureSensitiveTape },
  ],
  "Strapping Products": [
    { name: "PP & PET Strap",        image: ipm4 },
    { name: "Composite Cord Strap",  image: ms2 },
    { name: "CordedPolyesterStrapping", image: CordedPolyesterStrapping },
    { name: "Paper Strapping",  image: PaperStrapping },
    { name: "Polyester Strapping (PET Strapping)",  image: PolyesterStrapping },
    { name: "Polypropylene Strapping (PP Strapping)",  image: PolypropyleneStrapping },
  ],
  "Boxes & Pallets": [
    { name: "Corrugated Shipping Box",        image: CorrugatedBox },
    { name: "Die-Cut Box",   image: DieCutBox },
    { name: "PlywoodBox",   image: PlywoodBox },    
    { name: "RegularSlottedContainer",        image: RegularSlottedContainer },
{ name: "BoxesPallets",        image: BoxesPallets },      

  ],
};

const categories = Object.keys(categoryData);

const productSpecsData = [
  { category: "Stretch Film",    specs: "LLDPE, 17–23 micron, 500mm / 250mm width, hand & machine grade" },
  { category: "Air Bubble Roll", specs: "PE material, 5mm / 10mm bubble, various widths available" },
  { category: "Foam Sheet Roll", specs: "EPE / EVA / PU foam, 1mm–50mm thickness, custom sizes" },
  { category: "BOPP Tape",       specs: "40–50 micron, 48mm / 72mm width, 50m / 100m length" },
  { category: "PP Strap",        specs: "12mm / 15mm / 19mm width, 0.5mm–1mm thickness, various colors" },
  { category: "PET Strap",       specs: "High tensile strength, 12mm–19mm width, black / transparent" },
  { category: "Dunnage Air Bag", specs: "Level 1–5, PP woven / kraft paper, various sizes" },
  { category: "Silica Gel",      specs: "1g / 2g / 5g / 10g / 50g packets, white / blue indicating" },
  { category: "Corrugated Box",  specs: "3-ply / 5-ply / 7-ply, custom sizes, bursting strength as required" },
  { category: "FLC Box Pallet",  specs: "Injection moulded / roto / export pallet, various load capacities" },
];

const Material = () => {
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => { AOS.init({ duration: 800, once: true }); }, []);

  const items = categoryData[selectedCategory];

  return (
    <div className="material-page">

      {/* ── PAGE HERO ── */}
      <div className="page-hero">
        <div className="page-hero-content">
          <h1 data-aos="fade-up">Product Categories</h1>
          <p data-aos="fade-up" data-aos-delay="100">
            Detailed view of all industrial packaging materials we manufacture and supply
          </p>
        </div>
      </div>

      <Container className="mat-container">
        <h2 className="rotating-yellow-text text-center" data-aos="fade-up">Browse Product Categories</h2>
        <p className="section-sub" data-aos="fade-up">Select a category to explore our product range</p>

        {/* Mobile toggle */}
        <button className="mat-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
          {sidebarOpen ? "Hide Categories ✕" : "☰ Show Categories"}
        </button>

        <div className="mat-layout">

          {/* ── SIDEBAR ── */}
          <aside className={`mat-sidebar ${sidebarOpen ? "open" : ""}`}>
            {categories.map((cat, i) => (
              <button
                key={i}
                className={`mat-cat-btn ${selectedCategory === cat ? "active" : ""}`}
                onClick={() => { setSelectedCategory(cat); setSidebarOpen(false); }}
              >
                {cat}
              </button>
            ))}
          </aside>

          {/* ── MAIN CONTENT ── */}
          <div className="mat-main">
            <div className="mat-cat-header">
              <h2 className="mat-cat-title">{selectedCategory}</h2>
              <span className="mat-cat-count">{items.length} products</span>
            </div>

            {/* 3-column image grid, top-aligned */}
            <div className="mat-img-grid">
              {items.map((item, i) => (
                <div className="mat-img-card" key={i} data-aos="fade-up" data-aos-delay={i * 60}>
                  <div className="mat-img-wrap">
                    <img src={item.image} alt={item.name} />
                    <div className="mat-img-overlay">
                      <span className="mat-img-zoom">🔍</span>
                    </div>
                  </div>
                  <div className="mat-img-label">{item.name}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── SPECS TABLE ── */}
        <div className="specs-container mt-5 mb-5" data-aos="fade-up">
          <h2 className="rotating-yellow-text text-center">Product Specifications</h2>
          <p className="section-sub">Technical specifications for our key products</p>
          <div className="table-wrapper mt-4">
            <table className="specs-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Specifications</th>
                </tr>
              </thead>
              <tbody>
                {productSpecsData.map((item, i) => (
                  <tr key={i}>
                    <td>{item.category}</td>
                    <td>{item.specs}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Material;
